import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    redirect: {name: "wizard", params: {stepNumber: 1}},
    name: "slash",
  },
  {
    path: "/step/:stepNumber",
    name: "wizard",
    component: () =>
      import(/* webpackChunkName: "wizard" */ "../views/WizardView.vue"),
    props: true
  },
  {
    path: "/:installer_key",
    redirect: to => ({name: "installer_wizard", params: {stepNumber: 1, installer_key: to.params.installer_key}}),
    name: "installer_slash",
  },
  {
    path: "/:installer_key/step/:stepNumber",
    name: "installer_wizard",
    component: () =>
      import(/* webpackChunkName: "wizard" */ "../views/WizardView.vue"),
    props: true
  },
  {
    path: "/algemene-voorwaarden",
    name: "algemene-voorwaarden",
    component: () =>
      import(/* webpackChunkName: "legal" */ "../views/AlgemeneVoorwaardenView.vue"),
  },
  {
    path: "/:installer_key/algemene-voorwaarden",
    name: "installer-algemene-voorwaarden",
    component: () =>
      import(/* webpackChunkName: "legal" */ "../views/AlgemeneVoorwaardenView.vue"),
  },
  {
    path: "/privacy-statement",
    name: "privacy-statement",
    component: () =>
      import(/* webpackChunkName: "legal" */ "../views/PrivacyStatementView.vue"),
  },
  {
    path: "/:installer_key/privacy-statement",
    name: "installer-privacy-statement",
    component: () =>
      import(/* webpackChunkName: "legal" */ "../views/PrivacyStatementView.vue"),
  },
  {
    path: "/cookies",
    name: "cookies",
    component: () =>
      import(/* webpackChunkName: "legal" */ "../views/CookiesView.vue"),
  },
  {
    path: "/:installer_key/cookies",
    name: "installer-cookies",
    component: () =>
      import(/* webpackChunkName: "legal" */ "../views/CookiesView.vue"),
  },
  {
    path: "/style-showcase",
    name: "style-showcase",
    component: () =>
      import(/* webpackChunkName: "dev" */ "../views/StyleShowcaseView.vue"),
  },
  {
    path: "/:installer_key/style-showcase",
    name: "installer-style-showcase",
    component: () =>
      import(/* webpackChunkName: "dev" */ "../views/StyleShowcaseView.vue"),
    props: true
  },
  {
    path: "/thank-you",
    name: "thank-you",
    component: () =>
      import(/* webpackChunkName: "dev" */ "../views/ThankYouView.vue"),
  },
  {
    path: "/:installer_key/thank-you",
    name: "installer-thank-you",
    component: () =>
      import(/* webpackChunkName: "dev" */ "../views/ThankYouView.vue"),
    props: true
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(/*to, from, savedPosition*/) {
    // always scroll to top (because savedPosition only works with browser navigation and the system is not currently setup that way)
    return { top: 0 };
  },
});

export default router;
